import React from 'react';
import {Tabs} from '@components';
// import NewComment from './NewComment';
import CommentsHistory from './CommentsHistory';

const ManageComments = ({reportId}) => {
  // const newCommentCB = React.useCallback(
  //   (isActive) => <NewComment isActive={isActive} reportId={reportId} />,
  //   [reportId]
  // );
  const commentsHistoryCB = React.useCallback(
    (isActive) => <CommentsHistory isActive={isActive} reportId={reportId} />,
    [reportId]
  );

  const getTabItems = () => {
    const tabs = [
      // {
      //   tabKey: 'new-comment',
      //   tabLabel: 'New Comment',
      //   position: 1,
      //   content: newCommentCB,
      // },
      {
        tabKey: 'comments-history',
        tabLabel: 'Comments History',
        position: 2,
        content: commentsHistoryCB,
      },
    ];
    return tabs;
  };

  return (
    <div className="mt-2">
      <Tabs
        id="report-review-comments"
        defaultTab="comments-history"
        tabs={getTabItems()}
        tabPaneMinHeight="300px"
        contentOverflow="auto"
      />
    </div>
  );
};

export default ManageComments;
